export enum PlayerActionType {
  SET_IS_PLAYING = 'SET_IS_PLAYING',
  SET_START_TIME = 'SET_START_TIME',
  SET_END_TIME = 'SET_END_TIME',
}
